import { useToast } from "vue-toastification";
import config from "../config";
import { enqueueBackgroundTaskAndPoll } from "./backgroundTasks";
import { withLoadingScreen } from "./loading";

export function getSamplesDataTemplateUrl(requestCode, requestProtocol, experimentCode) {
    const reqAndProtocol = `${requestCode}_${requestProtocol}`;
    const filenamePrefix = `${experimentCode}sampData_`;
    return `${config.apiHost}/samples/${reqAndProtocol}/excel/sampData/${filenamePrefix}${reqAndProtocol}.xlsx`;
}

export async function uploadSampleDataFile(file, requestCode) {
    uploadFileAndPoll(
        file,
        requestCode,
        "importSamplesData",
        "Sample data file uploaded successfully"
    );
}

export async function uploadSampleSetupFile(file, requestCode) {
    uploadFileAndPoll(
        file,
        requestCode,
        "importRequestSamplesSetup",
        "Sample setup template uploaded successfully"
    );
}

async function uploadFileAndPoll(file, requestCode, taskType, successMessage) {
    const payload = {
        requestCode: requestCode,
        taskType: taskType,
    };
    const toast = useToast();

    await withLoadingScreen(async () => {
        const result = await enqueueBackgroundTaskAndPoll(payload, 5000, 20, file);
        if (result.status === "failed") {
            toast.error(result.more_info.error);
        } else {
            toast.success(successMessage);
        }
    });
}

const dataTemplateWorkflows = ["Analytical - HPLC", "Analytical - SDS-PAGE", "Outsourced"];

export function workflowSupportsSampleDataTemplate(sampleWorkflow) {
    return sampleWorkflow && dataTemplateWorkflows.includes(sampleWorkflow);
}

export function workflowSupportsPlateUpload(sampleWorkflow) {
    return sampleWorkflow && sampleWorkflow === "Analytical - Plate Reader";
}

export function workflowSupportsImageUpload(sampleWorkflow) {
    return sampleWorkflow && sampleWorkflow === "Analytical - SDS-PAGE";
}
